<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-08-11 13:54:47
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-16 18:31:22
-->
<template>
    <span>
      <!-- 导出订单弹窗 -->
      <el-dialog title="导出订单" :visible.sync="visible" width="400px" show-close>
          <div class="export-content">
            <p>当前共选中<span class="export-content-numb">{{ count }}</span>个样品订单</p>
            <p class="mt10">每次最大导出<span class="export-content-numb important">{{limit}}</span>个样品订单</p>
          </div>
          <span slot="footer">
              <el-button type="primary" @click="exportWaitSendOrder" :loading="loading">确定导出</el-button>
          </span>
      </el-dialog>
    </span>
</template>

<script>
import { exportApply, exportSelection, exportTobe, liveExport } from '@/api/cooperationProgress';
export default {
    name: "ExportOrder",
    computed: {
      disable() {
        return this.disabled;
      }
    },
    data() {
        return {
            visible: false,
            count: 0,
            limit: 1000, // 限制只能下载1000条数据
            state: 0,
            cooperate_ids: '',
            loading: false
        }
    },
    methods: {
        initExprot(cooperate_ids, state, count) {
          this.count = count
          this.cooperate_ids = cooperate_ids
          this.state = state
          this.visible = true
        },
        async exportWaitSendOrder() {
          const apis = {
            0: exportSelection,
            1: exportApply,
            2: exportTobe,
            3: liveExport
          };
          this.loading = true;
          try {
            const {download_url} = await apis[this.state]({cooperate_ids: this.cooperate_ids});
            this.loading = false;
            this.visible = false;
            window.open(download_url, '_blank');
          } catch (error) {
            if(error.code === -1) {
              this.$message.error(error.message);
            }
            this.loading = false;
          }
        }
    }
}
</script>
<style lang="less" scoped>
.export-content {
  color: @color-text-regular;
  &-numb {
    color: @color-text-primary;
    font-weight: 600;
    &.important {
      color: @color-primary;
    }
  }
}
.mt10 {
  margin-top: 10px;
}
</style>